
import "../../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_224_0_CarouselPagination";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_224_0_CarouselPagination__root","dot":"wds_1_224_0_CarouselPagination__dot"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"dotHeight":"4px"}; 
export var vars = {"wds-space-50":"--wds-space-50","wds-space-400":"--wds-space-400","wds-color-blue-0":"--wds-color-blue-0","wds-color-blue-300":"--wds-color-blue-300","wds-color-blue-200":"--wds-color-blue-200","wds-carousel-dots-width":"--wds-carousel-dots-width"}; 




